
import React, { Component } from "react";
import "./LocationSearchModal.css";

class MapPage extends Component {
  state = {
    isOpen: false,
    timeRemaining: "00:00:00",
  };

  componentDidMount() {
    this.updateBusinessStatus();
    this.statusTimer = setInterval(this.updateBusinessStatus, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.statusTimer);
  }

  getNextBusinessOpening = (now) => {
    const nextOpening = new Date(now);

    nextOpening.setHours(9, 0, 0, 0);

    if (nextOpening <= now || nextOpening.getDay() === 5 || nextOpening.getDay() === 6) {
      nextOpening.setDate(nextOpening.getDate() + 1);
    }

    while (nextOpening.getDay() === 5 || nextOpening.getDay() === 6) {
      nextOpening.setDate(nextOpening.getDate() + 1);
    }

    return nextOpening;
  };

  updateBusinessStatus = () => {
    const now = new Date();
    const day = now.getDay();

    const currentSeconds =
      now.getHours() * 3600 +
      now.getMinutes() * 60 +
      now.getSeconds();

    const openingSeconds = 9 * 3600;
    const closingSeconds = 17 * 3600;

    const isBusinessDay = day >= 0 && day <= 4;

    const isOpen =
      isBusinessDay &&
      currentSeconds >= openingSeconds &&
      currentSeconds < closingSeconds;

    let nextTarget;

    if (isOpen) {
      nextTarget = new Date(now);
      nextTarget.setHours(17, 0, 0, 0);
    } else {
      nextTarget = this.getNextBusinessOpening(now);
    }

    const remainingSeconds = Math.max(
      0,
      Math.floor((nextTarget.getTime() - now.getTime()) / 1000)
    );

    const hoursLeft = Math.floor(remainingSeconds / 3600);
    const minutesLeft = Math.floor((remainingSeconds % 3600) / 60);
    const secondsLeft = remainingSeconds % 60;

    const formattedTime =
      `${String(hoursLeft).padStart(2, "0")}:` +
      `${String(minutesLeft).padStart(2, "0")}:` +
      `${String(secondsLeft).padStart(2, "0")}`;

    this.setState({
      isOpen,
      timeRemaining: formattedTime,
    });
  };

  render() {
    return (
      <section className="location-section" dir="rtl">
        <div className="location-container">

          <div className="office-title">
            <span className="office-title-line"></span>

            <h2>משרדנו</h2>

            <p>רז יוסף – משרד עורכי דין</p>

            <span className="office-title-line"></span>
          </div>

          <div className="map-card">

            <div className="map-top-line">
              <span></span>
            </div>

            <div
              className="map-inner"
              style={{
                width: "100%",
                height: "400px",
              }}
            >
              <iframe
                title="משרד עורכי דין רז יוסף – רחוב האורזים 23, נתניה"
                src="https://www.google.com/maps?q=רחוב+האורזים+23,+נתניה,+ישראל&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            <div className="map-info">

              <div className="map-info-item">
                <div>
                  <span className="map-icon">⚖️</span>
                  <small>שם המשרד</small>
                  <strong>
                    רז יוסף – משרד עורכי דין
                  </strong>
                </div>
              </div>

              <div className="map-info-item">
                <div>
                  <span className="map-icon">📍</span>
                  <small>כתובת המשרד</small>
                  <strong>
                    רחוב האורזים 23, נתניה
                  </strong>

                  <a
                    href="https://waze.com/ul?q=רחוב%20האורזים%2023%20נתניה&navigate=yes"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="waze-button"
                  >
                    ניווט באמצעות Waze
                  </a>
                </div>
              </div>

              <div
                className="map-info-item"
                style={{ width: "100%" }}
              >
                <div style={{ width: "100%" }}>
                  <span className="map-icon">🕒</span>

                  <small>שעות פעילות</small>

                  <strong>
                    ימים א׳–ה׳ | 09:00–17:00
                  </strong>

                  <div
                    style={{
                      marginTop: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "15px",
                      flexWrap: "wrap",
                      width: "100%",
                    }}
                  >
                    <span
                      style={{
                        padding: "6px 16px",
                        borderRadius: "30px",
                        color: "#ffffff",
                        fontWeight: "bold",
                        fontSize: "13px",
                        backgroundColor: this.state.isOpen
                          ? "#239b56"
                          : "#d71920",
                      }}
                    >
                      {this.state.isOpen ? "פתוח עכשיו" : "סגור עכשיו"}
                    </span>

                    <span
                      style={{
                        fontSize: "14px",
                        color: "#777777",
                      }}
                    >
                      {this.state.isOpen
                        ? "סגירת המשרד בעוד:"
                        : "פתיחה הבאה בעוד:"}
                      {" "}

                      <strong
                        style={{
                          color: "#ffffff",
                          direction: "ltr",
                          display: "inline-block",
                          fontVariantNumeric: "tabular-nums",
                        }}
                      >
                        {this.state.timeRemaining}
                      </strong>
                    </span>
                  </div>
                </div>
              </div>

              <div className="map-info-item">
                <div>
                  <span className="map-icon">☎</span>
                  <small>טלפון</small>
                  <strong dir="ltr">
                    050-757-5775
                  </strong>
                </div>
              </div>

              <div className="map-info-item">
                <div>
                  <span className="map-icon">✉</span>
                  <small>דואר אלקטרוני</small>
                  <strong dir="ltr">
                    raz290174@gmail.com
                  </strong>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default MapPage;
